(() => {
  const parseNumberOr = (value, fallback) => {
    const parsed = Number.parseFloat(value);
    return Number.isNaN(parsed) ? fallback : parsed;
  };

  const initSwiper = (container) => {
    if (!container || container.dataset.swiperInitialized === 'true') return;
    if (typeof Swiper === 'undefined') return;

    const slidesMobile = parseNumberOr(container.dataset.swiperSlidesMobile, 1);
    const slidesTablet = parseNumberOr(container.dataset.swiperSlidesTablet, slidesMobile);
    const slidesDesktop = parseNumberOr(container.dataset.swiperSlidesDesktop, slidesTablet);
    const gapMobile = parseNumberOr(container.dataset.swiperGapMobile, 16);
    const gapDesktop = parseNumberOr(container.dataset.swiperGapDesktop, gapMobile);
    const disableDesktop = container.dataset.swiperDisableDesktop === 'true';
    const offsetBefore = parseNumberOr(container.dataset.swiperOffsetBefore, 0);
    const offsetAfter = parseNumberOr(container.dataset.swiperOffsetAfter, 0);
    const offsetBeforeMobile = parseNumberOr(container.dataset.swiperOffsetBeforeMobile, offsetBefore);
    const offsetAfterMobile = parseNumberOr(container.dataset.swiperOffsetAfterMobile, offsetAfter);
    const offsetBeforeDesktop = parseNumberOr(container.dataset.swiperOffsetBeforeDesktop, offsetBefore);
    const offsetAfterDesktop = parseNumberOr(container.dataset.swiperOffsetAfterDesktop, offsetAfter);
    const loop = container.dataset.swiperLoop === 'true';
    const loopFill = container.dataset.swiperLoopFill === 'true';
    const centered = container.dataset.swiperCentered === 'true';
    const centeredBounds = container.dataset.swiperCenteredBounds === 'true';
    const centerInsufficient = container.dataset.swiperCenterInsufficient === 'true';
    const centeredMobile = container.dataset.swiperCenteredMobile === 'true';
    const centeredDesktop = container.dataset.swiperCenteredDesktop === 'true';
    const groupMobile = parseNumberOr(container.dataset.swiperGroupMobile, 1);
    const groupDesktop = parseNumberOr(container.dataset.swiperGroupDesktop, groupMobile);

    const controlsRoot = container.closest('[data-swiper-root]') || container;
    const prevEl = controlsRoot.querySelector('[data-swiper-prev]');
    const nextEl = controlsRoot.querySelector('[data-swiper-next]');
    const currentEl = controlsRoot.querySelector('[data-swiper-counter-current]');
    const totalEl = controlsRoot.querySelector('[data-swiper-counter-total]');

    const options = {
      slidesPerView: slidesMobile,
      spaceBetween: gapMobile,
      watchOverflow: true,
      slidesOffsetBefore: offsetBeforeMobile,
      slidesOffsetAfter: offsetAfterMobile,
      centeredSlides: centered,
      centeredSlidesBounds: centeredBounds,
      centerInsufficientSlides: centerInsufficient,
      loop,
      slidesPerGroup: groupMobile,
      loopFillGroupWithBlank: loopFill,
      navigation: prevEl && nextEl ? { prevEl, nextEl } : undefined,
      breakpoints: {
        750: {
          slidesPerView: slidesTablet,
          spaceBetween: gapDesktop,
          slidesOffsetBefore: offsetBeforeDesktop,
          slidesOffsetAfter: offsetAfterDesktop,
          slidesPerGroup: groupDesktop,
          ...(centeredMobile ? { centeredSlides: true } : null),
        },
        990: {
          slidesPerView: slidesDesktop,
          spaceBetween: gapDesktop,
          slidesOffsetBefore: offsetBeforeDesktop,
          slidesOffsetAfter: offsetAfterDesktop,
          slidesPerGroup: groupDesktop,
          ...(centeredDesktop ? { centeredSlides: true } : { centeredSlides: false }),
        },
      },
      on: {
        init(swiperInstance) {
          if (totalEl) totalEl.textContent = String(swiperInstance.slides.length);
          if (currentEl) currentEl.textContent = String(swiperInstance.realIndex + 1);
        },
        slideChange(swiperInstance) {
          if (currentEl) currentEl.textContent = String(swiperInstance.realIndex + 1);
          if (container.dataset.swiperGallery === 'true') {
            const slide = swiperInstance.slides[swiperInstance.activeIndex];
            if (slide) {
              container.dispatchEvent(
                new CustomEvent('slideChanged', {
                  detail: {
                    currentPage: swiperInstance.realIndex + 1,
                    currentElement: slide,
                  },
                })
              );
            }
          }
        },
        resize(swiperInstance) {
          if (totalEl) totalEl.textContent = String(swiperInstance.slides.length);
        },
      },
    };

    const desktopMql = window.matchMedia('(min-width: 750px)');
    const gridBreakpointMql = window.matchMedia('(min-width: 1200px)');
    const toggleSwiper = () => {
      const shouldDisable = disableDesktop && gridBreakpointMql.matches;
      const existing = container.swiperInstance;

      if (shouldDisable) {
        if (existing && !existing.destroyed) {
          existing.destroy(true, true);
        }
        container.classList.add('swiper-disabled');
        return;
      }

      container.classList.remove('swiper-disabled');
      if (!existing || existing.destroyed) {
        container.swiperInstance = new Swiper(container, options);
      } else {
        existing.update();
      }
    };

    container.dataset.swiperInitialized = 'true';
    toggleSwiper();
    (disableDesktop ? gridBreakpointMql : desktopMql).addEventListener('change', toggleSwiper);
  };

  const initAllSwipers = (root = document) => {
    root.querySelectorAll('[data-swiper]').forEach((container) => initSwiper(container));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllSwipers());
  } else {
    initAllSwipers();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllSwipers(event.target);
  });
})();
